import React, { useState, useEffect } from 'react';
import styled from "styled-components";

const PageContainer = styled.div`
    position: fixed;
    inset: 0;
    background: var(--bg);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    z-index: 5000;
`;

const LoaderContainer = styled.div`
    position: relative;
    width: 150px;
    height: 150px;
`;

const Loader = styled.div`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 4px solid var(--brand-100);
    border-top-color: var(--brand-500);
    border-right-color: var(--accent-400);
    border-radius: 50%;
    animation: circle infinite 0.8s linear;

    @keyframes circle {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

const Logo = styled.img`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 92px;
    height: 92px;
    object-fit: contain;
    animation: pulse 1.6s ease-in-out infinite;

    @keyframes pulse {
        0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
        50% { transform: translate(-50%, -50%) scale(0.92); opacity: 0.85; }
    }
`;

const LoadingScreen = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return (
            <PageContainer>
                <LoaderContainer>
                    <Loader />
                    <Logo src="/logo.png" alt="Madagasikara Ekôlôjia Logo" />
                </LoaderContainer>
            </PageContainer>
        );
    }

    return children;
};

export default LoadingScreen;
